import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Radio } from 'lucide-react';
import { MobileNav } from '../components/MobileNav';
import { WinnerFeed } from '../components/WinnerFeed';

const playfair = "'Playfair Display', serif";

export const LiveWinner = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen pb-28" style={{ background: '#080C0A', fontFamily: "'Outfit', sans-serif" }} data-testid="live-winner-page">
      <header className="sticky top-0 z-40 backdrop-blur-2xl" style={{ background: 'rgba(8,12,10,0.9)', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="max-w-5xl mx-auto px-6 py-5 flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2" data-testid="live-winner-back">
            <ArrowLeft className="w-5 h-5" style={{ color: '#F8FAF9' }} />
            <span style={{ color: '#F8FAF9' }}>Beranda</span>
          </button>
          <div className="flex items-center gap-2">
            <Radio className="w-5 h-5 animate-pulse" style={{ color: '#EF4444' }} />
            <h1 className="text-xl md:text-2xl font-light" style={{ fontFamily: playfair, color: '#F8FAF9' }}>Live Winner</h1>
          </div>
          <span className="w-12" />
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-6 py-8">
        <p className="text-sm mb-6" style={{ color: '#A3B8AC' }}>
          Pemenang terbaru dari seluruh event Kuji — diperbarui realtime, identitas dimask demi privasi.
          Setiap entri diambil dari riwayat draw yang tercatat di server (tidak ada fake winner).
        </p>
        <WinnerFeed variant="inline" limit={50} />
      </main>
      <MobileNav />
    </div>
  );
};

export default LiveWinner;
